var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternetOfThings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 142.44 134.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-3);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{stroke:#fff;stroke-linejoin:round;}.cls-2{fill:url(#linear-gradient-6);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient);}.cls-9{fill:url(#radial-gradient-3);}.cls-9,.cls-10,.cls-11,.cls-12{fill-opacity:.75;}.cls-5{fill:rgba(255,255,255,.2);stroke-linecap:round;stroke-width:3px;}.cls-6{fill:url(#linear-gradient-5);}.cls-10{fill:url(#radial-gradient);}.cls-11{fill:url(#radial-gradient-2);}.cls-12{fill:url(#radial-gradient-4);}.cls-7{fill:none;}.cls-8{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 36.53,
    cy: 110.86,
    fx: 36.53,
    fy: 110.86,
    r: 9.26,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52a2f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 97.05,
    cy: 114.65,
    fx: 97.05,
    fy: 114.65,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 80.55,
    cy: 97.63,
    fx: 80.55,
    fy: 97.63,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 70.47,
    cy: 82.97,
    fx: 70.47,
    fy: 82.97,
    r: 9.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#d0e2f6",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8dc0f6",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#62aaf6",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52a2f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 73.55,
    y1: 123.68,
    x2: 80.55,
    y2: 123.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 93.55,
    y1: 130.68,
    x2: 100.55,
    y2: 130.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 101.07,
    y1: 105.09,
    x2: 108.07,
    y2: 105.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 33.03,
    y1: 110.86,
    x2: 40.03,
    y2: 110.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 67.05,
    y1: 107.81,
    x2: 74.05,
    y2: 107.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 49.1,
    y1: 120.56,
    x2: 56.1,
    y2: 120.56,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 36.53,
    cy: 110.86,
    r: 9.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 97.05,
    cy: 114.65,
    r: 9.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 80.55,
    cy: 97.63,
    r: 9.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M70.55,82.93h-9.26c0,5.08,4.18,9.26,9.26,9.26s9.26-4.18,9.26-9.26h-9.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 97.05,
    y1: 130.68,
    x2: 97.05,
    y2: 114.65
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "80.55 82.93 80.55 97.63 97.05 114.65"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "86.18 103.78 77.05 112.91 77.05 123.68"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 77.05,
    cy: 123.68,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 97.05,
    cy: 130.68,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "104.57 105.09 90.55 91.07 90.55 82.93"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 104.57,
    cy: 105.09,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "36.53 110.86 50.55 96.84 50.55 82.93"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 36.53,
    cy: 110.86,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 70.55,
    y1: 107.81,
    x2: 70.55,
    y2: 82.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 70.55,
    cy: 107.81,
    r: 3.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "52.6 119.76 52.79 101.98 60.55 94.96 60.55 82.93"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 52.6,
    cy: 120.56,
    r: 3.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M117.84,34.03c.12-1.08,.19-2.18,.19-3.29,0-16.15-13.09-29.24-29.24-29.24-13.42,0-24.71,9.04-28.16,21.35-3.64-2.2-7.9-3.46-12.46-3.46-13.34,0-24.15,10.81-24.15,24.15,0,3.03,.56,5.93,1.58,8.61h-8.7c-8.5,0-15.39,6.89-15.39,15.39h0c0,8.5,6.89,15.39,15.39,15.39H116.47c13.51,0,24.47-10.96,24.47-24.47s-10.22-23.72-23.1-24.43Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetOfThings);
export default __webpack_public_path__ + "static/media/internet-of-things.4dd709f1186c64adf28b64ef0e80ab23.svg";
export { ForwardRef as ReactComponent };